import React, { lazy, Suspense, memo } from 'react';
import Loader from '@components/common/Loader/newLoaderModal';

const KioskOrder = lazy(() => import('./kioskMenuOrder'));

const MenuOrder = props => {
  const ComponentToRender = KioskOrder;

  return (
    <Suspense fallback={<Loader />}>
      {ComponentToRender ? <ComponentToRender {...props} /> : null}
    </Suspense>
  );
};

export default memo(MenuOrder);
